<template>
  <a-card class="container">
    <a-page-header :title="group_type == 'cell' ? '分组管理' : '选配记录管理'" @back="back()" >
      <template #extra>
        <a-button type="primary" class="float-right" shape="round" @click="batch_add_items">批量添加个体</a-button>
      </template>
    </a-page-header>

    <a-card class="margin-top-20">
      <a-row>
        <a-col :span="8">
          <a-statistic title="农场名称" :value="farm_cell.farm ? farm_cell.farm.name : ''"></a-statistic>
        </a-col>
        <a-col :span="8">
          <a-statistic :title="group_type == 'cell' ? '农舍名称' : '选配记录名称'" :value="farm_cell.name"></a-statistic>
        </a-col>
        <a-col :span="8">
          <a-statistic title="当前个体数量" :value="farm_cell.item_count"></a-statistic>
        </a-col>
      </a-row>
    </a-card>

    <a-card :title="`${farm_cell.name} ${group_type == 'cell' ? '分群' : '选配记录'}个体列表`" class="margin-top-30" bordered
      :headStyle="headStyle">
      <item-table 
        :page_size="10" ref="itemTable" 
        @page-change="(page) => load_items(page)">
        <template slot="extra" slot-scope="row">
          <a-button type="primary" class="float-left" size="small" shape="round" @click="removeItemFromCell(row)">移除</a-button>
        </template>
      </item-table>
    </a-card>


    <a-card title="候选匹配个体" :headStyle="headStyle" class="margin-top-30" v-if="$_has('15002')">
      <!-- 筛选参数栏 -->
      <div class="filter-controls">
        <!-- 近交模式（最左侧） -->
        <div class="control-group">
          <label class="control-label">近交模式</label>
          <a-switch
            checked-children="开"
            unCheckedChildren="关"
            v-model="use_inbreeding_algo"
            @change="onInbreedingAlgoChange">
          </a-switch>
        </div>

        <!-- 近交系数阈值（近交模式下显示，label在上方） -->
        <div class="control-group" v-if="use_inbreeding_algo">
          <label class="control-label">近交系数阈值</label>
          <a-input-number
            v-model="xuan_pei_query.max_inbreeding"
            :min="0"
            :max="1"
            :step="0.01"
            :precision="4"
            placeholder="最大系数"
            style="width: 130px"
            @change="load_xuan_pei_items()">
          </a-input-number>
        </div>

        <!-- 匹配模式（近交模式下隐藏） -->
        <div class="control-group" v-if="!use_inbreeding_algo">
          <label class="control-label">匹配模式</label>
          <a-radio-group v-model="xuan_pei_query.match_all" @change="load_xuan_pei_items()">
            <a-radio-button :value="1">精确匹配</a-radio-button>
            <a-radio-button :value="0">模糊匹配</a-radio-button>
          </a-radio-group>
        </div>

        <!-- 排除亲缘（近交模式下隐藏） -->
        <div class="control-group" v-if="!use_inbreeding_algo">
          <label class="control-label">排除亲缘</label>
          <a-select
            v-model="xuan_pei_query.gen_num"
            placeholder="选择代数"
            style="width: 120px"
            allowClear
            @change="load_xuan_pei_items()">
            <a-select-option value="3">3代</a-select-option>
            <a-select-option value="4">4代</a-select-option>
            <a-select-option value="5">5代</a-select-option>
          </a-select>
        </div>

        <!-- 个体VID -->
        <div class="control-group">
          <label class="control-label">个体VID</label>
          <a-input
            v-model="xuan_pei_query.vid"
            placeholder="搜索"
            style="width: 150px"
            allowClear
            @pressEnter="load_xuan_pei_items">
          </a-input>
        </div>

        <!-- 状态筛选 -->
        <div class="control-group">
          <label class="control-label">状态筛选</label>
          <div class="switch-wrapper">
            <a-switch
              checked-children="可用"
              unCheckedChildren="全部"
              @change="on_state_select_change">
            </a-switch>
          </div>
        </div>
      </div>
      
        <!-- <a-button type="primary" v-for="item, index in xuan_pei_items" :key="index" @click="load_yu_zhong_results(item)">{{ item.vid }}</a-button> -->
      
      <a-table 
        :dataSource="xuan_pei_items"
        :columns="visibleHouXuanColumns"
        :pagination="xuan_pei_page"
        :loading="xuan_pei_loading"
        :rowClassName="inbreedingRowClass"
        @change="(page) => load_xuan_pei_items(page)">
        <template slot="vid" slot-scope="vid, row">
          <item-button :text="vid" :id="row.id || row.rf_id || row.id" :is_dead="row.is_dead"></item-button>
        </template>
        <template slot="export_tag" slot-scope="export_tag, farm_id">
          {{ export_tag || '-' }}
        </template>
        <template slot="father" slot-scope="father, row">
          <item-button :text="row.item_father" :id="row.father_id" :is_dead="row.is_dead"></item-button>
        </template>
        <template slot="mother" slot-scope="mother, row">
          <item-button :text="row.item_mother" :id="row.mother_id" :is_dead="row.is_dead"></item-button>
        </template>
        <template slot="birth_date" slot-scope="birth_date">
          {{ birth_date || '-' }}
        </template>
        <template slot="gebv_volume" slot-scope="gebv_volume, row">
          {{ row.gebv_volume }}
        </template>
        <template slot="inbreeding_coefficient" slot-scope="inbreeding_coefficient">
          <span :style="{ color: getInbreedingColor(inbreeding_coefficient) }">
            {{ formatInbreeding(inbreeding_coefficient) }}
          </span>
        </template>
        <template slot="min_predicted_offspring_f" slot-scope="min_predicted_offspring_f, row">
          <span :style="{ color: getInbreedingColor(min_predicted_offspring_f) }">
            {{ formatInbreeding(min_predicted_offspring_f) }}
          </span>
          <a-tooltip v-if="use_inbreeding_algo && getInbreedingLevel(min_predicted_offspring_f) === 'warning'" placement="top">
            <template slot="title">
              注意，存在一定近交风险，请确保父本的育种值（EBV）足够优秀以覆盖风险
            </template>
            <a-tag color="orange" style="margin-left: 4px; font-size: 11px; cursor: pointer;">警告</a-tag>
          </a-tooltip>
          <a-tooltip v-if="use_inbreeding_algo && getInbreedingLevel(min_predicted_offspring_f) === 'danger'" placement="top">
            <template slot="title">
              预测后代近交系数超过 6.25%，强烈不建议此配对
            </template>
            <a-tag color="red" style="margin-left: 4px; font-size: 11px; cursor: pointer;">禁止</a-tag>
          </a-tooltip>
        </template>
        <template slot="gender" slot-scope="gender">
          {{ gender == 0 ? '母' : '公' }}
        </template>
        <template slot="operation" slot-scope="scope, row">
          <a-button type="primary" size="small" @click="open_yu_zhong_result(row)">查看</a-button>
        </template> 
      </a-table>
    </a-card>

    <!-- 选配记录关系列表 -->
    <a-card title="配对关系列表" :headStyle="headStyle" class="margin-top-30" v-if="group_type == 'selectRecord'">
      <farm-cell-relation-table ref="farmCellRelationTable" :extra-params="relationQueryParams" :use-inbreeding-algo="use_inbreeding_algo" />
    </a-card>

    <a-modal :visible="show_yu_zhong_dialog" :width="1200"
      :title="`候选个体编号：${picked_yu_zhong_item.vid}`"
      @cancel="on_yu_zhong_dialog_close">
      <a-radio-group :default-value="use_inbreeding_algo ? 0 : 1" body-style="solid" v-model="yu_zhong_result_query.reverse_select"  @change="onReverseSelectChange" 
        class="margin-left-10">
        <a-radio-button :value="0">显示可匹配个体</a-radio-button>
        <a-radio-button :value="1">显示不可匹配个体</a-radio-button>
      </a-radio-group>
      <a-result
        v-if="yu_zhong_pagination.total == 0 && yu_zhong_result_query.reverse_select == 1"
        status="success"
        title="组内所有个体可配种"
        sub-title=""
      >
      </a-result>
      <a-result
        v-if="yu_zhong_pagination.total == 0 && yu_zhong_result_query.reverse_select == 0 && use_inbreeding_algo"
        status="warning"
        title="无可匹配个体"
        sub-title="所有候选个体的预测后代近交系数均超出阈值"
      >
      </a-result>
      <yuZhongResultTable
        v-show="yu_zhong_pagination.total > 0"
        ref="resultTable" @page-change="onYuZhongPageChange" :male_item="picked_male_item" :use-inbreeding-algo="use_inbreeding_algo" @yu-zhong-record-added="onYuZhongRecordAdded"></yuZhongResultTable>
    </a-modal>
    <farmCellAddItems ref="farmCellAddItems" @finish-edit="refresh_list"></farmCellAddItems>
  </a-card>
</template>

<script>
import itemTable from './../breed_items/components/itemTable.vue'
import yuZhongResultTable from '../yu_zhong/components/yuZhongResultTable.vue'
import FarmCellRelationTable from './FarmCellRelationTable.vue'
import ItemButton from '../components/ItemButton.vue';
import farmCellAddItems from './components/farmCellAddItems.vue';
import FarmCellAddItems from './components/farmCellAddItems.vue';
export default {
  components: {
    itemTable, yuZhongResultTable, FarmCellRelationTable, ItemButton, farmCellAddItems
  },
  data() {
    return {
      farm_cell: {},
      group_type: 'cell',
      cell_id: '',
      items: [],
      use_inbreeding_algo: false,
      xuan_pei_items: [],
      xuan_pei_loading: false,
      picked_male_item: {},
      show_yu_zhong_dialog: false,
      picked_yu_zhong_item: {},
      yu_zhong_result_count: 0,
      relationMaleItems: [],
      relationFemaleItems: [],
      yuZhongRelations: [],
      xuan_pei_page: {
        current: 1,
        total: 0,
        showTotal: total => `共 ${total} 条记录`
      },
      xuan_pei_query: {
        vid: '',
        farm_id: '',
        farm_cell_id: '',
        item_tag_id: '',
        gender: 1,
        page_no: 1,
        page_size: 10,
        match_all: 1,
        group_type: 'cell',
        gen_num: undefined,
        state: undefined,
        order_by: 'gebv_volume',
        use_inbreeding_algo: 0,
        max_inbreeding: 0.0625,
        match_mode: 'ALL'
      },
      yu_zhong_result_query: {
        id: '',
        page_no: 1,
        page_size: 10,
        farm_cell_id: '',
        reverse_select: 1,
        group_type: 'cell',
        order_by: 'gebv_volume',
        gen_num: undefined,
        use_inbreeding_algo: 0,
        max_inbreeding: 0.0625,
        match_mode: 'ALL'
      },
      yu_zhong_pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`
      },
      xuan_pei_columns: [
        {
          title: "Vid",
          dataIndex: "vid",
          key: "vid",
          scopedSlots: {customRender: 'vid'}
        },
        {
          title: "进口号",
          dataIndex: "export_tag",
          key: "export_tag",
          scopedSlots: {customRender: 'export_tag'}
        },
        {
          title: "RF-Id",
          dataIndex: "rf_id",
          key: "rf_id",
          scopedSlots: {customRender: 'rf_id'}
        },
        {
          title: "父亲",
          dataIndex: "father",
          key: "father",
          scopedSlots: {customRender: 'father'}
        },
        {
          title: "母亲",
          dataIndex: "mother",
          key: "mother",
          scopedSlots: {customRender: 'mother'}
        },
        {
          title: "出生日期",
          dataIndex: "birth_date",
          key: "birth_date",
          scopedSlots: {customRender: 'birth_date'}
        },
        {
          title: "GEBV",
          dataIndex: "gebv_volume",
          key: "gebv_volume",
          scopedSlots: {customRender: 'gebv_volume'}
        },
        {
          title: "性别",
          dataIndex: "gender",
          key: "gender",
          scopedSlots: {customRender: 'gender'}
        },
        {
          title: '变更操作',
          key: 'extra',
          scopedSlots: { customRender: 'extra' },
        }
      ],
      hou_xuan_columns: [
        {
          title: "Vid",
          dataIndex: "vid",
          key: "vid",
          scopedSlots: {customRender: 'vid'}
        },
        {
          title: "进口号",
          dataIndex: "export_tag",
          key: "export_tag",
          scopedSlots: {customRender: 'export_tag'}
        },
        {
          title: "父亲",
          dataIndex: "father",
          key: "father",
          scopedSlots: {customRender: 'father'}
        },
        {
          title: "母亲",
          dataIndex: "mother",
          key: "mother",
          scopedSlots: {customRender: 'mother'}
        },
        {
          title: "出生日期",
          dataIndex: "birth_date",
          key: "birth_date",
          scopedSlots: {customRender: 'birth_date'}
        },
        {
          title: "性别",
          dataIndex: "gender",
          key: "gender",
          scopedSlots: {customRender: 'gender'}
        },
        {
          title: "GEBV",
          dataIndex: "gebv_volume",
          key: "gebv_volume",
          scopedSlots: {customRender: 'gebv_volume'}
        },
        {
          title: "近交系数",
          dataIndex: "inbreedingCoefficient",
          key: "inbreeding_coefficient",
          width: 120,
          scopedSlots: {customRender: 'inbreeding_coefficient'},
          sorter: (a, b) => {
            const va = a.inbreedingCoefficient != null ? Number(a.inbreedingCoefficient) : 0
            const vb = b.inbreedingCoefficient != null ? Number(b.inbreedingCoefficient) : 0
            return va - vb
          },
        },
        {
          title: '操作',
          key: 'operation',
          scopedSlots: { customRender: 'operation' },
        }
      ],
      relationQueryParams: {
        item_select_record_id: undefined,
        farm_cell_id: undefined
      },
      relationColumns: [
        {
          title: "雄性个体",
          dataIndex: "male_item",
          key: "male_item",
          scopedSlots: {customRender: 'male_vid'}
        },
        {
          title: "雌性个体",
          dataIndex: "female_item",
          key: "female_item",
          scopedSlots: {customRender: 'female_vid'}
        },
        {
          title: "配对时间",
          dataIndex: "created_at",
          key: "created_at",
          scopedSlots: {customRender: 'created_at'}
        },
        {
          title: '操作',
          key: 'operation',
          scopedSlots: { customRender: 'operation' },
        }
      ],
      headStyle: {
        backgroundColor: '#2563EB', // 自定义 header 背景色
        color: '#efefef', // 自定义 header 文字颜色
        "border-radius": '10px 10px 0px 0px',
        "font-weight": 'bold'
      }
    }
  },
  created() {
    this.cell_id = this.$route.params.id
    this.group_type = this.$route.query.group_type
    
    // 根据路由参数设置查询参数
    if (this.group_type === 'selectRecord') {
      // 如果是选配记录类型，使用路由参数作为 item_select_record_id
      this.relationQueryParams.item_select_record_id = parseInt(this.cell_id);
      this.relationQueryParams.farm_cell_id = undefined;
    } else {
      // 如果不是选配记录类型，使用路由参数作为 farm_cell_id
      this.relationQueryParams.farm_cell_id = parseInt(this.cell_id);
      this.relationQueryParams.item_select_record_id = undefined;
    }
    
    this.refresh_list()
  },
  computed: {
    visibleHouXuanColumns() {
      if (!this.use_inbreeding_algo) {
        return this.hou_xuan_columns
      }
      // 近交模式下，在"近交系数"列后面插入"最低预测后代近交系数"列
      const cols = [...this.hou_xuan_columns]
      const idx = cols.findIndex(c => c.dataIndex === 'inbreedingCoefficient')
      if (idx >= 0) {
        cols.splice(idx + 1, 0, {
          title: "最低预测后代近交系数",
          dataIndex: "min_predicted_offspring_f",
          key: "min_predicted_offspring_f",
          scopedSlots: {customRender: 'min_predicted_offspring_f'},
          sorter: (a, b) => {
            const va = a.min_predicted_offspring_f != null ? a.min_predicted_offspring_f : 999
            const vb = b.min_predicted_offspring_f != null ? b.min_predicted_offspring_f : 999
            return va - vb
          },
        })
      }
      return cols
    }
  },
  methods: {
    back() {
      this.$router.push(`/farms/${this.farm_cell.farm_id}`)
    },
    load_items(page) {

      let query = {
        farm_cell_id: this.cell_id,
        group_type: this.group_type,
        order_by: 'gebv_volume'
      }
      if (page) {
        query['page_no'] = page.current
        query['page_size'] = page.pageSize
      }
      this.$api.get_breed_items(query).then(res => {
        if (res.code == 200) {
          this.items = res.data.list
          this.$refs.itemTable.open(res.data.list, res.data.page, false, this.xuan_pei_columns)
        }
      })
    },
    load_xuan_pei_items(page) {
      this.xuan_pei_loading = true
      this.xuan_pei_query.group_type = this.group_type
      this.xuan_pei_query.use_inbreeding_algo = this.use_inbreeding_algo ? 1 : 0
      this.yu_zhong_result_query.use_inbreeding_algo = this.use_inbreeding_algo ? 1 : 0
      this.yu_zhong_result_query.max_inbreeding = this.xuan_pei_query.max_inbreeding
      // 近交模式下，精确匹配/模糊匹配映射为 match_mode
      if (this.use_inbreeding_algo) {
        this.xuan_pei_query.match_mode = this.xuan_pei_query.match_all === 1 ? 'ALL' : 'ANY'
        this.yu_zhong_result_query.match_mode = this.xuan_pei_query.match_mode
      } else {
        this.xuan_pei_query.match_mode = 'ALL'
        this.yu_zhong_result_query.match_mode = 'ALL'
      }
      if (page) {
        this.xuan_pei_query.page_no = page.current
        this.xuan_pei_page.current = page.current
      } else {
        this.xuan_pei_query.page_no = 1
        this.xuan_pei_page.current = 1
      }
      this.$api.get_farm_cell_yu_zhong_result(this.xuan_pei_query).then(res => {
        if (res.code == 200) {
          this.xuan_pei_items = res.data
          this.xuan_pei_page = res.page
        }
      }).finally(() => {
        this.xuan_pei_loading = false
      })
    },
    onReverseSelectChange() {
      this.load_yu_zhong_results(this.picked_male_item)
    },
    onYuZhongPageChange(page) {
      this.yu_zhong_result_query.page_no = page
      this.yu_zhong_result_query.gen_num = this.xuan_pei_query.gen_num
      this.load_yu_zhong_results(this.picked_male_item)
    },
    async load_yu_zhong_results(item) {
      this.yu_zhong_result_query.farm_cell_id = this.cell_id
      this.yu_zhong_result_query.id = item.id
      this.yu_zhong_result_query.group_type = this.group_type
      this.yu_zhong_result_query.gen_num = this.xuan_pei_query.gen_num
      this.yu_zhong_result_query.use_inbreeding_algo = this.use_inbreeding_algo ? 1 : 0
      this.yu_zhong_result_query.max_inbreeding = this.xuan_pei_query.max_inbreeding
      this.yu_zhong_result_query.match_mode = this.use_inbreeding_algo
        ? (this.xuan_pei_query.match_all === 1 ? 'ALL' : 'ANY')
        : 'ALL'
      if (this.picked_male_item.id != item.id) {
        this.yu_zhong_result_query.page_no = 1
      }
      this.picked_male_item = item
      
      // 显示加载状态
      this.$refs.resultTable.showLoading = true
      
      const res = await this.$api.get_batch_yu_zhong_result(this.yu_zhong_result_query)
      this.yu_zhong_pagination.total = res.page.total
      this.yu_zhong_pagination.total_pages = res.page.total_pages
      this.$refs.resultTable.syncData(res.data, this.yu_zhong_pagination)
      this.$refs.resultTable.showLoading = false
    },
    open_yu_zhong_result(row) {
      this.show_yu_zhong_dialog = true
      this.picked_yu_zhong_item = row
      // 近交模式默认显示可匹配个体(0)，传统模式默认显示不可匹配个体(1)
      this.yu_zhong_result_query.reverse_select = this.use_inbreeding_algo ? 0 : 1
      this.load_yu_zhong_results(row)
    },
    on_yu_zhong_dialog_close() {
      this.show_yu_zhong_dialog = false
      this.$refs.resultTable.syncData([], {})
    },
    on_state_select_change(checked) {
      if (checked) {
        this.xuan_pei_query.state = 2
        this.load_xuan_pei_items()
      } else {
        this.xuan_pei_query.state = undefined
        this.load_xuan_pei_items()
      }
    },
    onInbreedingAlgoChange(checked) {
      this.use_inbreeding_algo = checked
      this.load_xuan_pei_items()
    },
    inbreedingRowClass(record) {
      if (!this.use_inbreeding_algo) return ''
      const level = this.getInbreedingLevel(record.min_predicted_offspring_f)
      if (level === 'danger') return 'inbreeding-danger-row'
      if (level === 'warning') return 'inbreeding-warning-row'
      return ''
    },
    // 两级阈值: 警告 3.125%, 禁止 6.25%
    getInbreedingLevel(val) {
      if (val === null || val === undefined) return 'unknown'
      const v = Number(val)
      if (v <= 0.03125) return 'safe'       // <= 3.125%
      if (v <= 0.0625) return 'warning'     // 3.125% < F <= 6.25%
      return 'danger'                       // > 6.25%
    },
    formatInbreeding(val) {
      if (val === null || val === undefined) return '待计算'
      return Number(val).toFixed(4)
    },
    getInbreedingColor(val) {
      if (val === null || val === undefined) return '#999'
      const v = Number(val)
      if (v <= 0.03125) return '#52c41a'   // 绿色 - 安全 (<= 3.125%)
      if (v <= 0.0625) return '#fa8c16'    // 橙色 - 警告 (3.125% < F <= 6.25%)
      return '#f5222d'                     // 红色 - 禁止 (> 6.25%)
    },
    onYuZhongRecordAdded() {
      // 当育种记录添加完成后，刷新候选匹配个体列表
      this.load_xuan_pei_items()
      // 同时也直接调用配对关系列表组件的刷新方法
      if (this.$refs.farmCellRelationTable) {
        this.$refs.farmCellRelationTable.refresh_list();
      }
    },
    batch_add_items() {
      this.$refs.farmCellAddItems.open(this.farm_cell, this.group_type)
    },
    refresh_list() {
      if (this.group_type == 'cell') {
        this.$api.get_farm_cell(this.$route.params.id).then(res => {
          if (res.code == 200) {
            this.farm_cell = res.data
            if (res.data.gender_group.length == 1) {
              this.xuan_pei_query.gender = res.data.gender_group[0].item_gender == 0 ? 1 : 0
            }
            this.xuan_pei_query.farm_id = res.data.farm_id
            this.xuan_pei_query.farm_cell_id = res.data.id
            this.load_items()
            this.load_xuan_pei_items()
          }
        })
      } else if (this.group_type == 'selectRecord') {
        this.$api.get_item_select_record_by_id(this.cell_id).then(res => {
          this.farm_cell = res.data
          if (res.data.gender_group.length == 1) {
            this.xuan_pei_query.gender = res.data.gender_group[0].item_gender == 0 ? 1 : 0
          }
          this.xuan_pei_query.farm_id = res.data.farm_id
          this.xuan_pei_query.farm_cell_id = this.cell_id
          this.load_items()
          this.load_xuan_pei_items()
          this.loadRelations()
        })
      }
    },
    removeItemFromCell(item) {
      let payload = {
        breed_item_id: item.id,
        group_type: this.group_type,
      }

      this.$confirm({
        title: '确认从该群中移除该条记录？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.$api.post_remove_item_from_cell(this.cell_id, payload).then(res => {
            if (res.code == 200) {
              this.$message.success('移除成功')
              this.refresh_list()
            }
          })
        }
      })
    },
    async loadRelations() {
      if (this.group_type !== 'selectRecord') return;
      try {
        const res = await this.$api.get_item_select_record_relations(this.cell_id);
        if (res.code === 200) {
          this.yuZhongRelations = res.data || [];
        }
      } catch (error) {
        console.error('加载配对关系失败:', error);
        this.$message.error('加载配对关系失败');
      }
    },
    deleteRelation(row) {
      const relationId = (row.male_item && row.male_item.relation_id) || (row.female_item && row.female_item.relation_id);
      const maleVid = (row.male_item && row.male_item.vid) || '-';
      const femaleVid = (row.female_item && row.female_item.vid) || '-';
      
      this.$confirm({
        title: '确认删除该配对关系？',
        content: `将移除 ${maleVid} 与 ${femaleVid} 的配对关系`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk: async () => {
          try {
            const res = await this.$api.delete_item_select_relation(relationId);
            if (res.code === 200) {
              this.$message.success('删除成功');
              this.loadRelations();
            } else {
              this.$message.error(res.message || '删除失败');
            }
          } catch (error) {
            console.error('删除配对关系失败:', error);
            this.$message.error('删除失败');
          }
        }
      });
    }
  }
}
</script>

<style scoped>
/* 筛选控件栏 */
.filter-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end; /* 所有控件组底部对齐 */
  gap: 32px;
  padding: 20px 0;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 20px;
}

.control-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.control-label {
  font-size: 13px;
  color: #595959;
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 1.5;
}

/* 近交警告行高亮（3.125% < F <= 6.25%） */
::v-deep .inbreeding-warning-row {
  background-color: #fffbe6 !important;
}

::v-deep .inbreeding-warning-row:hover > td {
  background-color: #fff1b8 !important;
}

/* 近交禁止行高亮（F > 6.25%） */
::v-deep .inbreeding-danger-row {
  background-color: #fff1f0 !important;
}

::v-deep .inbreeding-danger-row:hover > td {
  background-color: #ffccc7 !important;
}

/* 开关容器 - 统一高度对齐 */
.switch-wrapper {
  display: flex;
  align-items: center;
  height: 32px;
}

/* 表格样式优化 */
::v-deep .ant-table {
  font-size: 13px;
}

::v-deep .ant-table-thead > tr > th {
  background: linear-gradient(to bottom, #fafbfc, #f5f7fa);
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #e1e4e8;
  padding: 14px 16px;
}

::v-deep .ant-table-tbody > tr:hover > td {
  background: #f0f7ff !important;
}

::v-deep .ant-table-tbody > tr > td {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}

/* 按钮样式 */
::v-deep .ant-btn {
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s;
}

::v-deep .ant-btn-primary {
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
}

::v-deep .ant-btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.3);
}

/* 开关样式 - 统一高度 */
::v-deep .ant-switch {
  background-color: #bfbfbf;
  min-width: 44px;
  height: 22px; /* 标准开关高度 */
  line-height: 20px;
}

::v-deep .ant-switch-checked {
  background-color: #2563EB;
}

/* 输入框样式 - 统一高度 */
::v-deep .ant-input,
::v-deep .ant-input-number,
::v-deep .ant-select-selection {
  border-radius: 6px;
  transition: all 0.3s;
  height: 32px; /* 统一输入控件高度 */
}

::v-deep .ant-input-number {
  width: 100%;
}

::v-deep .ant-input-number-input {
  height: 30px;
}

::v-deep .ant-select-selection__rendered {
  line-height: 30px;
}

::v-deep .ant-input:focus,
::v-deep .ant-input-number:focus,
::v-deep .ant-select-focused .ant-select-selection {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

/* 单选按钮组 - 统一高度 */
::v-deep .ant-radio-group {
  border-radius: 6px;
  height: 32px;
}

::v-deep .ant-radio-button-wrapper {
  border-radius: 0;
  border: 1px solid #d9d9d9;
  transition: all 0.3s;
  padding: 0 16px;
  height: 32px;
  line-height: 30px;
}

::v-deep .ant-radio-button-wrapper:first-child {
  border-radius: 6px 0 0 6px;
}

::v-deep .ant-radio-button-wrapper:last-child {
  border-radius: 0 6px 6px 0;
}

::v-deep .ant-radio-button-wrapper-checked {
  border-color: #2563EB;
  color: #2563EB;
  background: #e6f7ff;
}
</style>